import React from "react";
import { Navbar, Container, Nav, Button, NavDropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../media/logo.svg";
import { api } from "../utils/api";
import { TeamContext } from "../utils/TeamContext";
import { UserContext } from "../utils/UserContext";

export default function NavBar() {
  const userContext = React.useContext(UserContext);
  const teamContext = React.useContext(TeamContext);
  const navigator = useNavigate();
  const location = useLocation();

  const navItems = [
    { access: userContext.access.ordersMy, path: "/my_orders", label: "Моя еда" },
    { access: userContext.access.ordersAll, path: "/all_orders", label: "Вся еда" },
    { access: userContext.access.exchange, path: "/exchanges", label: "Аукцион" },
    { access: userContext.access.application, path: "/applications", label: "Заявки" },
    { access: userContext.access.report, path: "/report", label: "Отчет" },
    { access: userContext.access.fridge, path: "/fridge", label: "Холодильник" },
    { access: userContext.access.users, path: "/users", label: "Пользователи" },
    { access: userContext.access.meals, path: "/meals", label: "Блюда" },
    { access: userContext.access.limits, path: "/limits", label: "Лимиты" },
    { access: userContext.access.isTeamAdmin, path: "/team", label: "Команда" },
    { access: userContext.isRoot, path: "/teams", label: "Команды" },
  ].filter((item) => item.access);

  const directoriesLabels = ["Блюда", "Лимиты"];
  const settingsLabels = ["Команда", "Команды", "Пользователи"];

  const dictionaryNav = navItems.filter((item) => directoriesLabels.includes(item.label));
  const settingsNav = navItems.filter((item) => settingsLabels.includes(item.label));
  const mainNav = navItems.filter(
    (item) => !directoriesLabels.includes(item.label) && !settingsLabels.includes(item.label)
  );
  const isActive = (path) => location.pathname.startsWith(path);
  const initials = userContext?.name
    ? userContext.name
        .split(" ")
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join("")
    : "?";

  return (
    <Navbar
      bg="transparent"
      expand="lg"
      collapseOnSelect
      className="app-navbar"
      style={{ maxWidth: 1540, width: "100%" }}
      onSelect={(eventKey) => {
        navigator(eventKey);
      }}
    >
      <Container fluid className="px-2">
        <Navbar.Brand
      onClick={() => {
        navigator("/my_orders");
      }}
      style={{ cursor: "pointer" }}
    >
      <div className="brand-wrap">
        <img alt="Лого" src={logo} className="brand-logo" />
        <div>
          <p className="brand-title m-0">{teamContext.name}</p>
        </div>
      </div>
    </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse>
          <Nav className="me-auto app-nav-links">
            {mainNav.map((item) => (
              <Nav.Link
                key={item.path}
                eventKey={item.path}
                active={isActive(item.path)}
              >
                {item.label}
              </Nav.Link>
            ))}
            {dictionaryNav.length ? (
              <NavDropdown
                title="Справочники"
                id="nav-directory"
                className={dictionaryNav.some((el) => isActive(el.path)) ? "active" : ""}
              >
                {dictionaryNav.map((item) => (
                  <NavDropdown.Item
                    key={item.path}
                    eventKey={item.path}
                    active={isActive(item.path)}
                  >
                    {item.label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            ) : (
              ""
            )}
            {settingsNav.length ? (
              <NavDropdown
                title="Настройки"
                id="nav-settings"
                className={settingsNav.some((el) => isActive(el.path)) ? "active" : ""}
              >
                {settingsNav.map((item) => (
                  <NavDropdown.Item
                    key={item.path}
                    eventKey={item.path}
                    active={isActive(item.path)}
                  >
                    {item.label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            ) : (
              ""
            )}
          </Nav>

          <div
            className="app-nav-user"
            role="button"
            onClick={() => navigator("/me")}
            style={{ cursor: "pointer" }}
          >
            <div className="user-chip">
              {userContext.avatar ? (
                <span className="user-avatar has-avatar">
                  <img src={userContext.avatar} alt={userContext.name} />
                </span>
              ) : (
                <span className="user-avatar">{initials}</span>
              )}
              <div className="d-flex flex-column">
                <span className="fw-semibold">{userContext.name}</span>
              </div>
            </div>
            {document.cookie.match(/inspiro_root/) ? (
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => api.rootLogout()}
              >
                Войти в себя
              </Button>
            ) : (
              ""
            )}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
